<template>
  <div id="app" class="h-full border-primary-200 border-t-4">
    <v-app :style="{ background: '#f0f8ff' }">
      <transition name="fade" mode="out-in" appear>
        <Global-Spinner v-if="loading" :loading="loading" />
        <router-view v-else />
      </transition>
    </v-app>
  </div>
</template>

<script>
import GlobalSpinner from "@/components/helpers/GlobalSpinner";
import Bus from "@/services/bus";

export default {
  name: "App",
  components: { GlobalSpinner },
  computed: {
    loading() {
      return Bus.globalLoading;
    },
  },
};
</script>
